
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SupplierPaymentService, SupplierPaymentDto } from '../supplier-payment.service';
import { NotificationService } from '../../../core/notification.service';

@Component({
    selector: 'app-supplier-payment-list',
    templateUrl: './supplier-payment-list.component.html',
    standalone: false
})
export class SupplierPaymentListComponent implements OnInit {
    items: SupplierPaymentDto[] = [];
    page = 1;
    pageSize = 20;
    totalPages = 1;
    totalItems = 0;
    status: string = '';
    fornecedorId: string = '';
    loading = false;
    processingExpire = false;

    constructor(
        private service: SupplierPaymentService,
        private notification: NotificationService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if (params['fornecedorId']) {
                this.fornecedorId = params['fornecedorId'];
            }
            this.load();
        });
    }

    load(): void {
        this.loading = true;
        this.service.listarTransacoes({
            page: this.page,
            pageSize: this.pageSize,
            status: this.status || undefined,
            fornecedorId: this.fornecedorId || undefined
        }).subscribe({
            next: (res) => {
                this.items = res.items;
                this.totalPages = res.totalPages;
                this.totalItems = res.totalItems;
                this.loading = false;
            },
            error: (err) => {
                console.error('Error loading payments', err);
                this.notification.showError('Erro ao carregar pagamentos');
                this.loading = false;
            }
        });
    }

    filter(): void {
        this.page = 1;
        this.load();
    }

    resetFilter(): void {
        this.status = '';
        this.fornecedorId = '';
        this.filter();
    }

    expireAll(): void {
        if (!confirm('Deseja expirar todas as transações vencidas?')) return;

        this.processingExpire = true;
        this.service.expirarTodosVencidos().subscribe({
            next: (res) => {
                this.notification.showSuccess(`${res.expiredCount} transações expiradas.`);
                this.processingExpire = false;
                this.load();
            },
            error: (err) => {
                console.error('Error expiring transactions', err);
                this.notification.showError('Erro ao expirar transações');
                this.processingExpire = false;
            }
        });
    }

    prev(): void {
        if (this.page > 1) {
            this.page--;
            this.load();
        }
    }

    next(): void {
        if (this.page < this.totalPages) {
            this.page++;
            this.load();
        }
    }

    getStatusClass(status: string): string {
        switch (status) {
            case 'PAID': return 'bg-green-100 text-green-800';
            case 'AWAITING_PAYMENT': return 'bg-yellow-100 text-yellow-800';
            case 'EXPIRED': return 'bg-gray-100 text-gray-800';
            case 'CANCELLED': return 'bg-red-100 text-red-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    }

    getStatusLabel(status: string): string {
        switch (status) {
            case 'PAID': return 'Pago';
            case 'AWAITING_PAYMENT': return 'Aguardando';
            case 'EXPIRED': return 'Expirado';
            case 'CANCELLED': return 'Cancelado';
            default: return status;
        }
    }
}
